export default theme => ({
    banner: {
        alignItems: 'center',
        display: 'flex',
        height: '40px',
        justifyContent: 'center',
        left: 0,
        position: 'fixed',
        top: 0,
        width: '100vw',
        zIndex: 999
    },
    error: {
        backgroundColor: '#C5002F',
    },
    icon: {
        marginRight: '30px'
    },
    info: {
        backgroundColor: '#0288d1',
    },
    message: {
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(1),
        marginInline: 'auto'
    },
    warning: {
        backgroundColor: '#FFC72C',
    }
})
